import i18n from 'i18n';

export const AllOption = {
  value: 'all',
  label: i18n.t('poll.create.form.placeholders.all'),
};
